module.exports = __webpack_public_path__ + "static/DSC_9433-a5636039214bebb9542d57b8430fb888.jpg";